import React from 'react'
import DepotMovementsListEssay from './components/Movements_list'

function DepotsMovemmentsEssay() {
  return (
    <div>
        <DepotMovementsListEssay />
    </div>
  )
}

export default DepotsMovemmentsEssay
